import * as React from "react";

import { IDayCell_Month } from "../../../classes/dayCell_Month";

export interface IMonthMoreEventsCount {
    dayCell: IDayCell_Month;
    isLoading: boolean;
    cellDate: Date;
    onSetCurrentDate: (event: any) => any;
    onSetViewMode: (event: any) => any;
}
export const MonthMoreEventsCount = (props: IMonthMoreEventsCount) => {

    const setToDailyViewModeAndSetCurrentDateToThisDate = (e) => {
        props.onSetCurrentDate(e);
        props.onSetViewMode(e);
    };

    let numEventsVisibleInCell = 0;
    for (let e = 0; e < 3; e++) { if (props.dayCell.slots[e] !== undefined) { numEventsVisibleInCell++; } }

    const totalNumberEvents = props.dayCell.totalNumberEvents;
    const numEventsNotVisible = totalNumberEvents - numEventsVisibleInCell;
    const ariaLabel = "plus " + numEventsNotVisible.toString() + " more events."; // TODO internationalize

    if (!props.isLoading) {
        return (
            <ul className="CAL-V-MV-row4 CAL-V-MV-events">
                {numEventsNotVisible > 0 &&
                    <li className="CAL-EV-Item CAL-EV-plus">
                        <a href="#!" onClick={setToDailyViewModeAndSetCurrentDateToThisDate} data-value="DAILYLIST" data-date={props.cellDate} aria-label={ariaLabel}>+{numEventsNotVisible}</a>
                    </li>
                }
            </ul>
        );
    } else {
        return null;
    }

};
